export const createTrackingIdPattern = (eventName: string, variant: string) =>
  `${eventName}-${variant}`;
